import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, Table, Badge, Alert, Modal } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaSearch, FaFileExcel, FaCheck, FaTimes } from "react-icons/fa";
import { homologacionExcelApi } from "../../../services/api/homologacionExcelApi";
import ModalHomologacionExcel from "../../../components/modals/ModalHomologacionExcel";

const MantenimientoHomologacionExcel = () => {
  const navigate = useNavigate();

  const [homologaciones, setHomologaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtro, setFiltro] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  const [homologacionToEdit, setHomologacionToEdit] = useState(null);

  // Cargar homologaciones
  useEffect(() => {
    fetchHomologaciones();
  }, []);

  const fetchHomologaciones = async () => {
    setLoading(true);
    try {
      const response = await homologacionExcelApi.getAll();
      setHomologaciones(response.data || []);
    } catch (error) {
      console.error("Error cargando homologaciones:", error);
      toast.error("Error al cargar homologaciones", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (homologacion) => {
    if (window.confirm(`¿Está seguro de eliminar la homologación "${homologacion.descripcion || 'sin descripción'}"?`)) {
      try {
        await homologacionExcelApi.delete(homologacion.id);
        toast.success("Homologación eliminada correctamente", { position: "top-right" });
        fetchHomologaciones();
      } catch (error) {
        console.error("Error al eliminar homologación:", error);
        toast.error(error.response?.data?.detail || "Error al eliminar homologación", { position: "top-right" });
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setHomologacionToEdit(null);
  };

  const handleSave = async (homologacionData) => {
    try {
      if (modalMode === 'create') {
        await homologacionExcelApi.create(homologacionData);
        toast.success("Homologación creada correctamente", { position: "top-right" });
      } else {
        // Para actualizar, enviar en el formato correcto
        const updateData = {
          descripcion: homologacionData.descripcion,
          activo: homologacionData.activo,
          detalle: homologacionData.detalle
        };
        await homologacionExcelApi.update(homologacionToEdit.id, updateData);
        toast.success("Homologación actualizada correctamente", { position: "top-right" });
      }
      
      handleCloseModal();
      fetchHomologaciones();
    } catch (error) {
      console.error('Error al guardar homologación:', error);
      toast.error(error.response?.data?.detail || "Error al guardar homologación", { position: "top-right" });
    }
  };

  // Filtrar homologaciones
  const homologacionesFiltradas = homologaciones.filter((hom) =>
    hom.descripcion?.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <>
      <style>
        {`
          .dh-maintenance-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          
          .dh-card-header {
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-weight: 700;
          }
          
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(251, 191, 36, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(251, 191, 36, 0.4);
            color: white;
          }
          
          .btn-dh-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-danger:hover {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          .dh-form-control {
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }
          
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
            background: white;
          }
          
          .dh-enhanced-table {
            border-collapse: separate;
            border-spacing: 0;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            background: white;
          }
          
          .dh-enhanced-table thead th {
            background: #374151 !important;
            color: white !important;
            font-weight: 700 !important;
            font-size: 0.875rem !important;
            text-transform: uppercase !important;
            padding: 1rem 0.75rem !important;
            border: none !important;
          }
          
          .dh-enhanced-table tbody td {
            padding: 0.75rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            font-size: 0.9rem;
            vertical-align: middle;
          }
          
          .dh-enhanced-table tbody tr:hover {
            background: linear-gradient(135deg, #f9fafb 0%, rgba(102, 126, 234, 0.02) 100%) !important;
          }
          
          .dh-badge-success {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: white;
            border-radius: 10px;
            padding: 6px 12px;
            font-weight: 600;
            font-size: 0.85rem;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
          }
          
          .dh-badge-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            border-radius: 10px;
            padding: 6px 12px;
            font-weight: 600;
            font-size: 0.85rem;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
          }
        `}
      </style>

      <div className="dh-maintenance-bg">
        <ToastContainer />
        
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="mb-0" style={{ fontSize: '2.2rem', fontWeight: 700 }}>
                  <FaFileExcel className="me-3" />
                  Mantenimiento de Homologación Excel
                </h1>
                <p className="mb-0 mt-2" style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                  Gestión de parametría para mapeo de columnas de Excel de proveedores
                </p>
              </div>
              <Button 
                className="btn-dh-secondary d-flex align-items-center"
                onClick={() => navigate("/home")}
              >
                <FaArrowLeft className="me-2" />
                Volver
              </Button>
            </div>
          </Container>
        </div>

        <Container fluid className="py-4">
          <Row>
            <Col lg={12}>
              <Card className="dh-card">
                <Card.Header className="dh-card-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Lista de Homologaciones</h5>
                    <Button
                      onClick={() => {
                        setModalMode('create');
                        setHomologacionToEdit(null);
                        setShowModal(true);
                      }}
                      className="btn-dh-primary d-flex align-items-center"
                    >
                      <FaPlus className="me-2" />
                      Nueva Homologación
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: '2rem' }}>
                  <div className="mb-4">
                    <div className="position-relative">
                      <Form.Control
                        type="search"
                        className="dh-form-control"
                        placeholder="Buscar por descripción..."
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        style={{ paddingLeft: '3rem' }}
                      />
                      <FaSearch 
                        className="position-absolute" 
                        style={{ 
                          left: '1rem', 
                          top: '50%', 
                          transform: 'translateY(-50%)', 
                          color: '#6b7280' 
                        }} 
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table className="dh-enhanced-table">
                      <thead>
                        <tr>
                          <th>Descripción</th>
                          <th className="text-center">Col. Fecha</th>
                          <th className="text-center">Col. Tipo Servicio</th>
                          <th className="text-center">Col. N° Documento</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="6" className="text-center py-5">
                              <div className="d-flex flex-column align-items-center">
                                <div className="spinner-border text-primary mb-3" role="status">
                                  <span className="visually-hidden">Cargando...</span>
                                </div>
                                <span className="text-muted">Cargando homologaciones...</span>
                              </div>
                            </td>
                          </tr>
                        ) : homologacionesFiltradas.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center py-5">
                              <Alert variant="info" className="mb-0">
                                <FaFileExcel className="me-2" />
                                No se encontraron homologaciones
                              </Alert>
                            </td>
                          </tr>
                        ) : (
                          homologacionesFiltradas.map((hom) => (
                            <tr key={hom.id}>
                              <td style={{ fontWeight: '600', color: '#374151' }}>
                                {hom.descripcion || '-'}
                              </td>
                              <td className="text-center">
                                <Badge bg="info">{hom.detalle?.columna_fecha_atencion || '-'}</Badge>
                              </td>
                              <td className="text-center">
                                <Badge bg="info">{hom.detalle?.columna_tipo_servicio || '-'}</Badge>
                              </td>
                              <td className="text-center">
                                <Badge bg="info">{hom.detalle?.columna_numero_documento || '-'}</Badge>
                              </td>
                              <td className="text-center">
                                {hom.activo ? (
                                  <Badge className="dh-badge-success">
                                    <FaCheck /> Activo
                                  </Badge>
                                ) : (
                                  <Badge className="dh-badge-danger">
                                    <FaTimes /> Inactivo
                                  </Badge>
                                )}
                              </td>
                              <td className="text-center">
                                <div className="d-flex gap-2 justify-content-center">
                                  <Button
                                    variant="warning"
                                    size="sm"
                                    className="btn-dh-warning"
                                    onClick={() => {
                                      setModalMode('edit');
                                      setHomologacionToEdit(hom);
                                      setShowModal(true);
                                    }}
                                  >
                                    <FaEdit />
                                  </Button>
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    className="btn-dh-danger"
                                    onClick={() => handleDelete(hom)}
                                  >
                                    <FaTrash />
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ModalHomologacionExcel
        show={showModal}
        onHide={handleCloseModal}
        onSave={handleSave}
        homologacion={homologacionToEdit}
      />
    </>
  );
};

export default MantenimientoHomologacionExcel;
